export const isStillWelcomeTime = (welcomeHrs: number, created?: number) => {
  if (!created || !welcomeHrs) {
    return false;
  }
  const expirationDate = new Date(created * 1000);
  // add welcomeHrs hours to creation date
  expirationDate.setHours(expirationDate.getHours() + welcomeHrs);
  // now should be less than created date + welcomeHrs
  return Date.now() < expirationDate.valueOf();
};
